import React from 'react';
import { IconSearch } from '../icons';

const SearchInput = ({ value, onChange, placeholder = 'Search…', width = 194, variant = 'surface' }) => (
  <div
    className={`flex items-center gap-2 rounded-lg h-8 px-2 max-w-full ${
      variant === 'outline' ? 'bg-card border border-line' : 'bg-surface'
    }`}
    style={{ width }}
  >
    <IconSearch size={14} className="text-ink-muted shrink-0" />
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="flex-1 min-w-0 bg-transparent outline-none text-xs tracking-[0.4px] text-ink placeholder:text-ink-placeholder"
    />
  </div>
);

export default SearchInput;
